/* DIY Bakery — Shopify theme
   Warenkorb über die Shopify AJAX Cart API.

   Theme-Einstellung «Shop aktiv»:
     ein  — Kauf-Buttons legen in den Warenkorb, Schublade zeigt den Warenkorb
     aus  — Kauf-Buttons öffnen dieselbe Schublade mit «Bald erhältlich»
            und dem Eintrag in die Warteliste. Es wird nichts bestellt. */

(function () {
  "use strict";

  var CFG = window.DIYB || {};
  var SHOP = CFG.shopEnabled === true;
  var R = CFG.routes || {};
  var S = CFG.strings || {};

  /* ---------- helpers ---------- */

  var chf = function (cents) {
    return "CHF " + (cents / 100).toFixed(2);
  };

  var toast = document.querySelector(".toast");
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2400);
  }

  /* ---------- overlay header: solid bar drops in once scrolled ---------- */

  var overlayHeader = document.querySelector(".overlay-header .site-header");
  if (overlayHeader) {
    var hero = document.querySelector(".hero");
    var onHeaderScroll = function () {
      /* the bar drops only once the hero image has left the frame */
      var heroGone = hero
        ? hero.getBoundingClientRect().bottom <= overlayHeader.offsetHeight
        : window.scrollY > 60;
      overlayHeader.classList.toggle("scrolled", heroGone);
    };
    window.addEventListener("scroll", onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ---------- collection tabs ---------- */

  var tabs = document.querySelectorAll(".tab");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) {
        t.classList.toggle("active", t === tab);
        t.setAttribute("aria-selected", t === tab ? "true" : "false");
      });
      document.querySelectorAll(".tab-panel").forEach(function (p) {
        p.classList.toggle("active", p.dataset.panel === tab.dataset.tab);
      });
    });
  });

  /* ---------- quantity steppers ---------- */

  document.querySelectorAll(".card, .pdp-buy").forEach(function (scope) {
    var qtyOut = scope.querySelector(".qty output");
    var minus = scope.querySelector("[data-minus]");
    var plus = scope.querySelector("[data-plus]");
    if (!qtyOut || !minus || !plus) return;

    minus.addEventListener("click", function () {
      qtyOut.textContent = Math.max(1, parseInt(qtyOut.textContent, 10) - 1);
    });
    plus.addEventListener("click", function () {
      qtyOut.textContent = Math.min(99, parseInt(qtyOut.textContent, 10) + 1);
    });
  });

  /* ---------- drawer (shared by the cart and the «Bald erhältlich» panel) ---------- */

  var drawer = document.querySelector(".cart-drawer");
  var overlay = document.querySelector(".cart-overlay");
  var closeBtn = document.querySelector(".cart-close");

  function openDrawer() {
    document.body.classList.add("cart-open");
    if (drawer) drawer.setAttribute("aria-hidden", "false");
  }
  function closeDrawer() {
    document.body.classList.remove("cart-open");
    if (drawer) drawer.setAttribute("aria-hidden", "true");
  }

  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* ---------- shop off: «Bald erhältlich» ---------- */

  if (!SHOP) {
    document.querySelectorAll("[data-soon]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openDrawer();
        var field = document.getElementById("soon-email");
        if (field) setTimeout(function () { field.focus(); }, 380);
      });
    });

    /* nach dem Absenden lädt Shopify die Seite neu — Schublade wieder aufmachen,
       damit die Danke-Meldung nicht unsichtbar bleibt */
    if (window.__diybSoonPosted) openDrawer();

    return;
  }

  /* ---------- cart ---------- */

  var itemsEl = document.querySelector(".cart-items");
  var totalEl = document.querySelector(".cart-total output");
  var countEl = document.querySelector(".cart-count");
  var cartBtn = document.querySelector(".cart-btn");
  var checkoutBtn = document.querySelector(".checkout");

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = chf(cart.total_price);
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-empty">' + (S.empty || "") + "</p>";
      return;
    }

    itemsEl.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") + '" alt="">'
          : "";
        var meta = [];
        if (item.variant_title && item.variant_title !== "Default Title") meta.push(item.variant_title);
        meta.push(item.quantity + " Stk.");

        return (
          '<div class="cart-item">' +
          img +
          "<div><h5>" + item.product_title + "</h5>" +
          '<p class="ci-meta">' + meta.join(" · ") + "</p>" +
          '<button class="ci-remove" data-key="' + item.key + '">Entfernen</button></div>' +
          '<span class="ci-price">' + chf(item.final_line_price) + "</span>" +
          "</div>"
        );
      })
      .join("");
  }

  function refresh() {
    return fetch(R.cart, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { /* Warenkorb bleibt, wie er ist */ });
  }

  if (cartBtn) {
    cartBtn.addEventListener("click", function () { refresh(); openDrawer(); });
  }

  /* ---------- add to cart ---------- */

  document.querySelectorAll("[data-variant-id]").forEach(function (scope) {
    var addBtn = scope.querySelector(".add");
    if (!addBtn || addBtn.disabled) return;

    var qtyOut = scope.querySelector(".qty output");
    var select = scope.querySelector(".variant-select");

    addBtn.addEventListener("click", function () {
      var id = select ? select.value : scope.dataset.variantId;
      var qty = qtyOut ? parseInt(qtyOut.textContent, 10) : 1;

      addBtn.disabled = true;
      fetch(R.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          if (qtyOut) qtyOut.textContent = "1";
          showToast(S.added || "✓");
          return refresh();
        })
        .then(openDrawer)
        .catch(function () { showToast(S.error || "Fehler"); })
        .then(function () { addBtn.disabled = false; });
    });
  });

  /* ---------- remove (delegated) ---------- */

  if (itemsEl) {
    itemsEl.addEventListener("click", function (e) {
      var key = e.target.dataset ? e.target.dataset.key : null;
      if (!key) return;

      fetch(R.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { showToast(S.error || "Fehler"); });
    });
  }

  /* ---------- checkout ---------- */

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      window.location.href = R.checkout || "/checkout";
    });
  }

  refresh();
})();
